import { useEffect, useState } from "react";
import { RiCheckboxCircleFill, RiCloseCircleFill } from "react-icons/ri";
import { Link, useSearchParams } from "react-router-dom";

import SearchInput from "@/components/SearchInput";
import Table from "@/components/Table";
import api from "@/services/api";
import { captureError } from "@/services/error";

const List = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    size: Number(searchParams.get("size")) || 25,
    from: Number(searchParams.get("from")) || 0,
    search: searchParams.get("search") || "",
    department: searchParams.get("department") || null,
    city: searchParams.get("city") || null,
  });

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const query = {
          from: filters.from,
          size: filters.size,
        };
        if (filters.city) query.city = filters.city;
        if (filters.department) query.department = filters.department;
        if (filters.search) query.search = filters.search;
        setSearchParams(new URLSearchParams(query));

        const res = await api.post("/organization/search", query);
        if (!res.ok) throw res;
        setData(res.data);
        setTotal(res.total);
      } catch (error) {
        captureError(error, { extra: { filters } });
      }
      setLoading(false);
    };
    fetchData();
  }, [filters]);

  return (
    <div className="space-y-12 bg-white p-4 shadow-lg sm:p-12">
      <title>API Engagement - RNA - Administration</title>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h2 className="text-2xl font-semibold">{total.toLocaleString("fr")} d'associations référencées</h2>

        <SearchInput
          value={filters.search}
          onChange={(search) => setFilters({ ...filters, search })}
          className="min-w-[250px] flex-1 lg:max-w-[25%]"
          placeholder="Rechercher par mot-clé"
        />
      </div>

      <div className="border-grey-border overflow-x-auto border p-4 sm:p-6">
        <div className="min-w-[600px]">
        <Table
          caption="Liste des organisations"
          header={[{ title: "Titre de l'organisation", width: "40%" }, { title: "RNA" }, { title: "SIRET" }, { title: "Créée le" }, { title: "Statut" }]}
          page={filters.from}
          pageSize={filters.size}
          onPageChange={(page) => setFilters({ ...filters, from: (page - 1) * filters.size })}
          length={total}
          loading={loading}
        >
          {data.map((item, i) => {
            const organizationId = item.id ?? `organization-${i}`;
            return (
              <tr key={organizationId} className={`${i % 2 === 0 ? "bg-table-even" : "bg-table-odd"} table-row`}>
                <td className="p-4">
                  <Link to={`/admin-organization/${organizationId}`} className="text-blue-france line-clamp-3 max-w-xl flex-1 px-2">
                    {item.title}
                  </Link>
                </td>
                <td className="px-4">{item.rna}</td>
                <td className="px-4">{item.siret}</td>
                <td className="px-4">{item.createdAt ? new Date(item.createdAt).toLocaleDateString("fr") : "-"}</td>
                <td className="px-6">
                  <div className="flex w-16 items-center">
                    {item.status === "ACTIVE" ? (
                      <div className="flex items-center gap-2">
                        <p>Active</p>
                        <RiCheckboxCircleFill className="text-success" aria-hidden="true" />
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <p>Inactive</p>
                        <RiCloseCircleFill className="text-error" aria-hidden="true" />
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </Table>
        </div>
      </div>
    </div>
  );
};

export default List;
